import List from './List'
import Detail from './Detail'

const ArticleReports = () => ({
  path: '/article-reports',
  children: [List(), Detail()],
})

export default ArticleReports
